export const TOOL_STATUS = {
    DELETED: 0,
    ACTIVE: 1,
    REPAIR: 2,
    WRITTEN_OFF: 3,
    LOST: 4,
};
/** Порядок у фільтрі / селекті */
export const TOOL_STATUS_ALL = [
    TOOL_STATUS.ACTIVE,
    TOOL_STATUS.REPAIR,
    TOOL_STATUS.LOST,
    TOOL_STATUS.WRITTEN_OFF,
    TOOL_STATUS.DELETED,
];
/** За замовчуванням: усі, крім списаний і видалений */
export const TOOL_STATUS_DEFAULT_FILTER = [
    TOOL_STATUS.ACTIVE,
    TOOL_STATUS.REPAIR,
    TOOL_STATUS.LOST,
];
export const isToolStatusFinal = (status) => status === TOOL_STATUS.DELETED || status === TOOL_STATUS.WRITTEN_OFF;
export const TOOL_TRANSFER_STATUS = {
    CANCELLED: -1,
    PENDING: 0,
    CONFIRMED: 1,
};
export const isToolStatusTransferable = (status) => status === TOOL_STATUS.ACTIVE || status === TOOL_STATUS.REPAIR;
/** Короткий коментар до передачі (1–3 речення) */
export const TOOL_TRANSFER_COMMENT_MAX_LENGTH = 500;
export const TOOL_CALIBRATION_RESULT = {
    FAILED: 0,
    PASSED: 1,
};
export const TOOL_CALIBRATION_STATUS = {
    CANCELLED: -1,
    ACTIVE: 1,
};
/** Короткий коментар до повірки (як у передачі) */
export const TOOL_CALIBRATION_COMMENT_MAX_LENGTH = 500;
